import paginate from 'jw-paginate'; //https://jasonwatmore.com/post/2018/08/07/javascript-pure-pagination-logic-in-vanilla-js-typescript

/**
 * PAGINATION
 * 
 * Recoit le nombre d'items affiché actuellement sur la page
 */

export const paging = {
	currentPage: null,

	init(jsonOrigin,currentPage, pageSize) {
		// init json
		this.jsonOrigin = jsonOrigin;
		this.jsonPaging = this.jsonOrigin;
		//
		this.totalItems = this.jsonOrigin.length;
		this.pageSize = pageSize;
		this.currentPage = currentPage  || this.pageSize;

		
		// this.updateDatasPaginate();

		// premier rendu
		this.updateAll();
		
		// return this.jsonPaging;
		setTimeout(()=>{
			this.changeCurrentPage();
		}, 10)
	
	},

	updatePaging() {
		// update la pagination et son affichage
		this.pagination = new Paging(this.datasPaginate);
	},

	updateDatasPaginate() {
		// console.log(this.datasPaginate);
		return (this.datasPaginate = paginate(this.totalItems, this.currentPage, this.pageSize));
	},

	updateJsonPaging() {
		return (this.jsonPaging = this.jsonOrigin.slice(
			this.datasPaginate.startIndex,
			this.datasPaginate.endIndex + 1
		));
	},

	updateAll() {
		this.updateDatasPaginate();
		this.updatePaging();
		this.updateJsonPaging();
	},

	constrollers() {
		let numbers = document.querySelectorAll('.paging__item button');

		numbers.forEach((number) => {
			if(number.getAttribute('listener') !== true) {
				number.addEventListener('click', (e) => {
					// console.log('click on page');
					// e.target.parentNode.querySelector('.active').classList.remove('active')
					e.target.classList.add('active');
					this.currentPage = parseInt(e.target.innerHTML);
					this.updateAll();
					// déclanche l'event changeCurrentPage avec les infos
					this.changeCurrentPage();
				});
			}
		});

		// GESTION DES PREV  / NEXT
		
		if(this.currentPage >= 1 && this.currentPage < this.datasPaginate.endPage){
			// console.log(this.currentPage)
			document.querySelector('.paging__next').classList.remove('disable');
		}

		if(this.currentPage >= 2 ){
			document.querySelector('.paging__prev').classList.remove('disable');
		}

		if(document.querySelector('.paging__next:not(.disable)')){
			document.querySelector('.paging__next:not(.disable)').onclick = () => {
				if(this.currentPage < this.datasPaginate.endPage ){
					this.nextPage();
				}
			};
		}

		if(document.querySelector('.paging__prev:not(.disable)')){
			document.querySelector('.paging__prev:not(.disable)').onclick = () => {
				if(this.currentPage > 1 ){
					this.prevPage();
				}
			};
		}
		
	},

	prevPage() {
		// console.log('page précedente', this.currentPage);
			this.currentPage -= 1;
			this.updateAll();
			this.changeCurrentPage();
			
	},

	nextPage() {
		// console.log('page suivante', this.currentPage);
			this.currentPage += 1;
			this.updateAll();
			this.changeCurrentPage();
	},

	changeCurrentPage() {
		const event = new CustomEvent('currentPageChange', {
			detail: {
				pageNumber: this.currentPage,
				datasPaginate: this.datasPaginate,
				json: this.jsonPaging
			}
		});
		
		document.scrollingElement.scrollTop = 0;

		document.querySelector('.paging').dispatchEvent(event);

		// gestion des pages avec changement d'url
		// le but étant d'aller sur un article de revenir sur la bonne pagination
		history.pushState(this.currentPage, "page", `#${this.currentPage}`)

	
	}
};

class Paging {
	constructor({ currentPage, pages }) {
		this.numbersMARKUP = '';
		this.currentPage = currentPage;

		if (pages.length > 1) {
			pages.forEach((page) => {
				if (page === parseInt(currentPage)) {
					this.numbersMARKUP += `<li class="paging__item"><button class="active">${page}</button></li>`;
				} else {
					this.numbersMARKUP += `<li class="paging__item"><button>${page}</button></li>`;
				}
			});

			this.markup = `
				<nav class="paging__wrapper grid__12col">
							 <button class="paging__prev disable" ><span></span></button>
					<ul class="paging__list">
						${this.numbersMARKUP}
					</ul>
					<button class="paging__next disable"><span></span></button>
				</nav>`;
		} else {
			this.markup = ``;
		}
		this.render();
	}
	render() {
		// console.log('render pagination');
		document.querySelector('.paging').innerHTML = this.markup;
		paging.constrollers();
	}
}
